import { isValidPhoneNumber } from "react-phone-number-input";

export const formatNumber = (phone: string) => {
  return `${phone}`;
};

interface ValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const validatePhoneNumber = (value: string) => {
  if (value) {
    const normalizedValue = value.replace(/\D/g, "");

    // Example: for Nigerian numbers
    if (normalizedValue.startsWith("234")) {
      return /^(234)?[789][01]\d{8}$/.test(normalizedValue);
    } else if (normalizedValue.startsWith("+234")) {
      return /^\+234[789][01]\d{8}$/.test(normalizedValue);
    } else {
      return /^\+?\d{1,3}\d{4,14}$/.test(normalizedValue);
    }
  }
  return false;
};

export const hasInvalidValues = (
  validationState: Record<string, string>,
): boolean => {
  return Object.values(validationState).some((value) => value.trim() !== "");
};